/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  InputNumber,
  Modal,
  Table,
  Typography,
  message,
  Select,
  Popconfirm,
  Empty,
  Descriptions,
  AutoComplete,
  Card,
  Col,
  Flex,
  Row,
  Space,
  Steps,
  Radio,
  Divider,
} from "antd";
import {
  SaveFilled,
  QuestionCircleOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  CheckCircleFilled,
  FileAddOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import {
  productspecificationForm,
  columnsParametersEditable,
  columnsMicroParametersEditable,
  columnsCustomParametersEditable,
  componentsEditable,
  defaultParamenter,
  defaultParamenterMicro,
  defaultParamenterMetal,
  allergenStandardsDefault,
  opStorageConditions,
  gmoConditions,
  halalConditions,
  opMicroDescription,
  opMetalDescription,
  columnMetal,
} from "./model";
import { ModalSamplePreparation } from "../../components/modal/sample-preparation/modal-sample-preparation";
import ModalMicrobiological from "../../components/modal/microbiological/ModalMicrobiological";
import ModalTreatment from "../../components/modal/treatment/ModalTreatment";
import ModalCustomers from "../../components/modal/customers/ModalCustomers";
import dayjs from "dayjs";
import { delay, capitalizeFirst } from "../../utils/util";
import { useLocation, useNavigate } from "react-router-dom";
import ProductSpecificationService from "../../service/ProductSpecification.service";
import SamplePreparationService from "../../service/SamplePreparation.service";
// import { RiDeleteBin5Line } from "react-icons/ri";
import { CloseCircleFilledIcon } from "../../components/icon";
import { TbFileSearch } from "react-icons/tb";
import ModalAllergenStandard from "../../components/modal/allergen-standard/ModalAllergenStandard";
import AllergenStandardService from "../../service/AllergenStandard.service";

const pspservice = ProductSpecificationService();
const spservice = SamplePreparationService();
const allergenService = AllergenStandardService();

const gotoFrom = "/product-specification";
const dateFormat = "DD/MM/YYYY";

const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
  version: 1,
};

function ProductSpecificationManage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { config } = location.state || { config: null };
  const [form] = Form.useForm();
  /** Modal handle */
  const [isOpenModalMicro, setIsOpenModalMicro] = useState(false);
  const [isOpenModalTreatment, setIsOpenModalTreatment] = useState(false);
  /** ProductSpecification state */
  const [pspCode, setPspCode] = useState(null);
  /** Detail Data State */
  const [formDetail, setFormDetail] = useState(productspecificationForm);
  const [openSPModal, setOpenSPModal] = useState(false);
  const [openCustomer, setOpenCustomer] = useState(false);
  /* ทะเบียนข้อความกฎหมาย Allergen ผู้ใช้เพิ่มเองได้ */
  const [openAllergen, setOpenAllergen] = useState(false);
  const [allergenOptions, setAllergenOptions] = useState(
    allergenStandardsDefault
  );
  const [version, setVersion] = useState(0);
  const [choosed, setChoosed] = useState(false);
  const [parameters, setParameters] = useState(defaultParamenter);
  const [parametersCustomer, setParametersCustomer] = useState([]);
  const [parametersMicro, setParametersMicro] = useState(
    defaultParamenterMicro
  );
  const [parametersTreatment, setParametersTreatment] = useState([]);

  /* โหลดรายการกฎหมาย Allergen จากทะเบียน ถ้าโหลดไม่ได้ใช้ค่าตั้งต้นเดิม */
  const loadAllergenOptions = () => {
    allergenService
      .list()
      .then((res) => {
        const rows = res.data?.data || [];
        if (rows.length > 0) {
          setAllergenOptions(rows.map((r) => ({ value: r.name })));
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    loadAllergenOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [customerRow, setCustomerRow] = useState({});

  useEffect(() => {
    const initial = async () => {
      if (config?.action === "copy") {
        // console.log(config.code);
        setChoosed(true);
        setVersion(config.code.version + 1);
        setFormDetail(config.code);
        setPspCode(config.code.psp_code);
        setParametersTreatment(config.code.treatment_process);
        const newParameter = (config.code.phy_para || defaultParamenter).map(
          (m, i) => ({ ...m, seq: i + 1 })
        );
        setParametersCustomer(config.code.customer_para || []);
        setParameters(newParameter || defaultParamenter);
        setParametersMicro(config.code.micro_para || defaultParamenterMicro);
        form.setFieldValue("remark", config.code.remark);
        form.setFieldValue(
          "storage_conditions",
          config.code.storage_conditions
        );
        form.setFieldValue("shelf_life", config.code.shelf_life);
        form.setFieldValue("shelf_life_unit", config.code.shelf_life_unit);
        form.setFieldValue("micro_description", config.code.micro_description);
        form.setFieldValue("metal_description", config.code.metal_description);
        form.setFieldValue("gmo_status", config.code.gmo_status);
        form.setFieldValue("halal_status", config.code.halal_status);
        form.setFieldValue("sp_status", config.code.sp_status); //
        // Sample Status

        // remark: config.code.remark ,storage_conditions:config.code.storage_conditions
      } else if (config?.action === "edit") {
        // console.log(config.code);
        setChoosed(true);
        setVersion(config.code.version);
        setFormDetail(config.code);
        setPspCode(config.code.psp_code);
        setParametersTreatment(config.code.treatment_process);
        const newParameter = (config.code.phy_para || defaultParamenter).map(
          (m, i) => ({ ...m, seq: i + 1 })
        );
        setParametersCustomer(config.code.customer_para || []);
        setParameters(newParameter || defaultParamenter);
        setParametersMicro(config.code.micro_para || defaultParamenterMicro);
        form.setFieldValue("remark", config.code.remark);
        form.setFieldValue(
          "storage_conditions",
          config.code.storage_conditions
        );
        form.setFieldValue("shelf_life", config.code.shelf_life);
        form.setFieldValue("shelf_life_unit", config.code.shelf_life_unit);
        form.setFieldValue("micro_description", config.code.micro_description);
        form.setFieldValue("metal_description", config.code.metal_description);
        form.setFieldValue("gmo_status", config.code.gmo_status);
        form.setFieldValue("halal_status", config.code.halal_status);
        form.setFieldValue("sp_status", config.code.sp_status); //
        // Sample Status

        // remark: config.code.remark ,storage_conditions:config.code.storage_conditions
      } else {
        const { data: code } = (
          await pspservice.code().catch((e) => {
            message.error("get ProductSpecification code fail.");
          })
        ).data;
        setVersion(0);
        setPspCode(code);
        const newParameter = (config.code.phy_para || defaultParamenter).map(
          (m, i) => ({ ...m, seq: i + 1 })
        );
        setParameters(newParameter || defaultParamenter);
      }
    };

    initial();
    return () => {};
  }, []);

  const handleAddParameter = () => {
    setParameters([
      ...parameters,
      {
        seq: parameters.length + 1,
        phy_name: `parameter ${parameters.length + 1}`,
        limit_number: null,
        cutout: null,
        remark: null,
      },
    ]);
  };

  const handleAddParameterCustomer = () => {
    setParametersCustomer([
      ...parametersCustomer,
      {
        seq: parametersCustomer.length + 1,
        cuscode: null,
        cusname: null,
        remark: null,
      },
    ]);
  };

  const handleChooseMicroValue = (v) => {
    // console.log(v);
    setParametersMicro(v);
  };

  const handleChooseTreatmentValue = (v) => {
    setParametersTreatment(v);
    // console.log(v);
  };

  const handleConfirm = () => {
    form
      .validateFields()
      .then((v) => {
        const header = {
          ...formDetail,
          version: version,
          psp_code: pspCode,
          micro_description: formDetail.micro_description,
          metal_description: formDetail.metal_description,
          storage_conditions: formDetail.storage_conditions,
          gmo_status: formDetail.gmo_status,
          halal_status: form.getFieldValue("halal_status"),
          shelf_life: formDetail.shelf_life,
          shelf_life_unit: formDetail.shelf_life_unit,
          psp_date: dayjs().format("YYYY-MM-DD"),
          remark: form.getFieldValue("remark"),
        };

        const parm = {
          header,
          physical: parameters,
          customer: parametersCustomer,
          micro: parametersMicro,
          treatment: parametersTreatment,
          metal: defaultParamenterMetal,
        };
        // console.log(parm)
        const actions =
          config?.action === "edit" ? pspservice.update : pspservice.create;
        // const actions = pspservice.create;
        actions(parm)
          .then((r) => {
            handleClose().then((r) => {
              message.success("Request ProductSpecification success.");
            });
          })
          .catch((err) => {
            message.error("Request ProductSpecification fail.");
            console.warn(err);
          });
      })
      .catch((err) => {
        Modal.error({
          title: "ข้อมูลยังไม่ครบถ้วน",
          content: "กรุณากรอกข้อมูลให้ครบ",
        });
      });
  };

  const handleCancel = () => {
    pspservice
      .deleted(config?.code)
      .then((_) => {
        handleClose().then((r) => {
          message.success("ยกเลิกPSPเรียบร้อย.");
        });
      })
      .catch((err) => {
        console.warn(err);
        const {
          data: { message: mes },
        } = err.response;
        message.error(mes || "error request");
      });
  };

  const handleClose = async () => {
    navigate(gotoFrom, { replace: true });
    await delay(300);
    // console.clear();
  };

  const handleBack = async () => {
    if (config?.action === "create") {
      navigate(gotoFrom, { replace: true });
    } else {
      navigate("/product-specification/view", {
        state: {
          config: {
            ...mngConfig,
            title: "View",
            code: pspCode,
            action: "view",
          },
        },
        replace: true,
      });
    }
    await delay(300);
    // console.clear();
  };

  const handleDelete = (code, seq) => {
    const newData = parameters
      .filter((val) => val?.seq !== seq)
      .map((m, i) => ({ ...m, seq: i + 1 }));
    setParameters([...newData]);
  };

  const handleDeleteCustom = (code, seq) => {
    const newData = parametersCustomer
      .filter((val) => val?.seq !== seq)
      .map((m, i) => ({ ...m, seq: i + 1 }));
    setParametersCustomer([...newData]);
  };

  const handleAction = (record) => {
    return parameters.length >= 1 ? (
      <Button
        className="bt-icon"
        size="small"
        danger
        icon={<DeleteOutlined />}
        onClick={() => handleDelete(record?.phy_name, record.seq)}
      />
    ) : null;
  };

  const handleActionCustomer = (record) => {
    return parametersCustomer.length >= 1 ? (
      <Button
        className="bt-icon"
        size="small"
        danger
        icon={<DeleteOutlined />}
        onClick={() => handleDeleteCustom(record?.cuscode, record.seq)}
      />
    ) : null;
  };

  const handleSave = (row) => {
    const newData = (r) => {
      const newData = [...parameters];

      const ind = newData.findIndex((item) => row.seq === item?.seq);
      const item = newData[ind];

      newData.splice(ind, 1, {
        ...item,
        ...row,
      });
      return newData;
    };
    setParameters([...newData()]);
  };

  const handleSaveCustomer = (row) => {
    const newData = (r) => {
      const newData = [...parametersCustomer];
      const ind = newData.findIndex((item) => row.seq === item?.seq);
      const item = newData[ind];
      newData.splice(ind, 1, {
        ...item,
        ...row,
      });
      return newData;
    };
    setParametersCustomer([...newData()]);
  };

  const handleModalCustomerSelect = (e, row) => {
    setOpenCustomer(true);
    setCustomerRow(row);
  };

  const handleChooseCustomer = (v) => {
    const newData = {
      ...customerRow,
      cuscode: v.cuscode,
      cusname: v.cusname,
    };

    // console.log(newData, value);
    handleSaveCustomer(newData);
  };

  const handleChooseValue = (v) => {
    setChoosed(true);

    spservice
      .get_spdetail_forpsp(v.spcode)
      .then((res) => {
        const {
          master,
          data,
          parameter,
          allergen: { allergen },
        } = res.data;
        let allergenArr = [];
        if (!!allergen) {
          allergenArr = [...new Set(allergen.split(","))].map((srt) =>
            capitalizeFirst(srt)
          );
          // alert(allergenArr.join(", "))
        }
        // setAllergens(allergenArr.join(", "));
        let ingredients = "";
        if (data.length > 0) {
          ingredients = data
            .map((item, idx) => {
              if (idx < 3) {
                return `${item.stnameEN} (${
                  item.percent ? (item.percent * 100).toFixed(2) + "%" : ""
                })`;
              }
              return item.stnameEN;
            })
            .join(", ");
        }
        // alert(v.allergen_standards);

        setFormDetail((state) => ({
          ...state,
          ...v,
          ingredients: ingredients,
          allergenic: master.allergen_standards,
          allergenic_info: allergenArr.join(", "),
          shelf_life: master.shelf_life,
          shelf_life_unit: master.shelf_life_unit,
          pkcode: master.pkcode,
          remark: master.remark,
          sp_status: "sample",
        }));
        form.setFieldsValue({ ...formDetail });
        setParameters(parameter);
      })
      .catch((err) => {
        message.error("ไม่พบข้อมูล SP");
        setFormDetail((state) => ({ ...state, ...v, Ingredients: "" }));
      });

    // console.log(v);
  };

  /** setting column table */
  const column = columnsParametersEditable(handleSave, {
    handleAction,
  });

  const columnCus = columnsCustomParametersEditable(
    handleSaveCustomer,
    handleModalCustomerSelect,
    { handleActionCustomer }
  );

  const columnMicrobiological = columnsMicroParametersEditable(handleSave);

  ///** button */

  const SectionTop = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <Button
            style={{ width: 120 }}
            icon={<ArrowLeftOutlined />}
            onClick={() => {
              handleBack();
            }}
          >
            กลับ
          </Button>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {formDetail.doc_status === "ยังไม่ได้รับของ" &&
            config?.action !== "create" && (
              <Popconfirm
                placement="topRight"
                title="ยืนยันการยกเลิก"
                description="คุณแน่ใจที่จะยกเลิกPSP?"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={() => handleCancel()}
              >
                <Button
                  className="bn-center justify-center"
                  icon={<CloseCircleFilledIcon style={{ fontSize: "1rem" }} />}
                  type="primary"
                  style={{ width: "9.5rem" }}
                  danger
                >
                  ยกเลิกPSP
                </Button>
              </Popconfirm>
            )}
          <Button
            className="bn-center justify-center"
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            style={{ width: "9.5rem" }}
            onClick={() => {
              handleConfirm();
            }}
            // disabled={formDetail.doc_status !== "ยังไม่ได้รับของ"}
          >
            Save
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  const SectionChooseMicro = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            Microbiological Specification
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<FileAddOutlined style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              setIsOpenModalMicro(true);
            }}
          >
            Select Microbiological
          </Button>
        </Flex>
      </Col>
    </Flex>
  );

  const SectionChooseMetal = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            Heavy Metal
          </Typography.Title>
        </Flex>
      </Col>
      {/* <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<FileAddOutlined style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              setIsOpenModalMicro(true);
            }}
          >
            Select Heavy metal
          </Button>
        </Flex>
      </Col> */}
    </Flex>
  );

  const SectionChooseTreatment = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            Treatment & Processing
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<FileAddOutlined style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              setIsOpenModalTreatment(true);
            }}
          >
            Select Treatment
          </Button>
        </Flex>
      </Col>
    </Flex>
  );

  const SectionChooseProduct = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0 items-center"
    >
      <Col xs={24} sm={24} md={15} lg={15} xl={15} xxl={15}>
        <Flex
          align="center"
          className="justify-center md:justify-start lg:justify-start xl:justify-start"
        >
          <Typography.Title level={3} className="m-0">
            PSP Code : {pspCode}
          </Typography.Title>
        </Flex>
      </Col>
      <Col xs={24} sm={24} md={2} lg={2} xl={2} xxl={2}>
        <Flex
          align="center"
          className="justify-center md:justify-start lg:justify-start xl:justify-start"
        >
          <Typography.Title level={3} className="m-0">
            Version : {version}
          </Typography.Title>
        </Flex>
      </Col>
      <Col xs={24} sm={24} md={4} lg={4} xl={4} xxl={4}>
        <Flex gap={10} align="center" className="justify-start sm:justify-end">
          <Typography.Title level={3} className="m-0">
            PSP Date : {dayjs().format(dateFormat)}
          </Typography.Title>
          {/* <Form.Item name="pspdate" className="!m-0">
            <DatePicker
              className="input-40"
              allowClear={false}
              onChange={handleQuotDate}
              format={dateFormat}
              disabled
            />
          </Form.Item> */}
        </Flex>
      </Col>
      <Col xs={24} sm={24} md={12} lg={3} xl={3} xxl={3}>
        <Flex
          align="center"
          className="justify-center md:justify-end lg:justify-end xl:justify-end"
        >
          {config.action === "create" ? (
            <>
              <Button
                className="bn-center bn-primary-outline"
                icon={<TbFileSearch style={{ fontSize: "1.34rem" }} />}
                onClick={() => setOpenSPModal(true)}
              >
                Select SP
              </Button>
            </>
          ) : (
            ""
          )}
        </Flex>
      </Col>
    </Row>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <Button
            style={{ width: 120 }}
            icon={<ArrowLeftOutlined />}
            onClick={() => {
              handleBack();
            }}
          >
            กลับ
          </Button>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            className="bn-center justify-center"
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            style={{ width: "9.5rem" }}
            onClick={() => {
              handleConfirm();
            }}
            // disabled={formDetail.doc_status !== "ยังไม่ได้รับของ"}
          >
            Save
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  const SectionDescription = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0 items-center"
    >
      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
        <Flex
          vertical
          align="top"
          className="justify-start md:justify-start lg:justify-start xl:justify-start width-100"
        >
          <Form.Item name="remark" label="หมายเหตุ">
            <Input.TextArea
              rows={5}
              placeholder="บันทึกแค่ภายในไม่ Print"
              value={formDetail.remark}
              onChange={(e) => {
                setFormDetail((state) => ({
                  ...state,
                  remark: e.target.value,
                }));
              }}
            />
          </Form.Item>
        </Flex>
      </Col>
    </Row>
  );

  const SectionMicro = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0 items-center"
    >
      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
        <Flex
          vertical
          align="top"
          className="justify-start md:justify-start lg:justify-start xl:justify-start width-100"
        >
          <AutoComplete
            style={{ height: 40, width: "100%" }}
            options={opMicroDescription}
            placeholder="Enter Micro Description"
            filterOption={(inputValue, option) =>
              option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1
            }
            value={formDetail.micro_description}
            onChange={(value) => {
              setFormDetail((state) => ({
                ...state,
                micro_description: value,
              }));
            }}
            allowClear
          />
        </Flex>
      </Col>
    </Row>
  );

  const SectionMetal = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0 items-center"
    >
      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
        <Flex
          vertical
          align="top"
          className="justify-start md:justify-start lg:justify-start xl:justify-start width-100"
        >
          <AutoComplete
            style={{ height: 40, width: "100%" }}
            options={opMetalDescription}
            placeholder="Enter Metal Description"
            filterOption={(inputValue, option) =>
              option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1
            }
            value={formDetail.metal_description}
            onChange={(value) => {
              setFormDetail((state) => ({
                ...state,
                metal_description: value,
              }));
            }}
            allowClear
          />
        </Flex>
      </Col>
    </Row>
  );

  const SectionStep = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0 items-center"
    >
      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
        <Flex
          vertical
          align="top"
          className="justify-start md:justify-start lg:justify-start xl:justify-start width-100"
        >
          <Steps
            type="navigation"
            size="small"
            current={-1}
            className="site-navigation-steps"
            items={parametersTreatment}
          />
        </Flex>
      </Col>
    </Row>
  );

  const dsItems = () => {
    const master = formDetail;

    return [
      {
        label: "Product Name",
        labelStyle: { verticalAlign: "top", maxWidth: 250, minWidth: 130 },
        contentStyle: { verticalAlign: "top", minWidth: "6vw" },
        // children: master.spname,
        children: (
          <Input
            onChange={(e) => {
              setFormDetail((state) => ({
                ...state,
                spname: e.target.value,
              }));
            }}
            value={formDetail.spname}
            placeholder="Enter Product Name"
            style={{ width: "100%" }}
          />
        ),
        span: { xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 },
      },
      {
        label: "Product Code",
        labelStyle: { verticalAlign: "top", maxWidth: 205, minWidth: 130 },
        contentStyle: { verticalAlign: "top", minWidth: "6vw" },
        // children: master.spname,
        children: (
          <Input
            onChange={(e) => {
              setFormDetail((state) => ({
                ...state,
                product_code: e.target.value,
              }));
            }}
            value={formDetail.product_code}
            placeholder="Enter Product Code"
            style={{ width: "100%" }}
          />
        ),
        span: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 },
      },
      {
        label: "Sample Code",
        labelStyle: { verticalAlign: "top", maxWidth: 205, minWidth: 105 },
        contentStyle: { verticalAlign: "top", minWidth: "6vw" },
        children: master.spcode,
        span: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 },
        // span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
      },
      {
        label: "Packaging type/size",
        labelStyle: { verticalAlign: "top", maxWidth: 205, minWidth: 105 },
        contentStyle: { verticalAlign: "top", minWidth: "6vw" },
        children: (
          <Input
            onChange={(e) => {
              setFormDetail((state) => ({
                ...state,
                pkname: e.target.value,
              }));
            }}
            value={formDetail.pkname}
            placeholder="Enter Packaging"
            style={{ width: "100%" }}
          />
        ),
        span: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 },
      },
      {
        label: "Sample Status",
        labelStyle: { verticalAlign: "top", maxWidth: 205, minWidth: 165 },
        contentStyle: { verticalAlign: "top", minWidth: "6vw" },
        children: (
          <Radio.Group
            value={formDetail.sp_status}
            onChange={(e) => {
              setFormDetail((state) => ({
                ...state,
                sp_status: e.target.value,
              }));
            }}
          >
            <Radio.Button value="sample">Sample</Radio.Button>
            <Radio.Button value="pilot test">Pilot Test</Radio.Button>
            <Radio.Button value="commercial">Commercial</Radio.Button>
            <Radio.Button value="internal">Internal</Radio.Button>
          </Radio.Group>
        ),
        span: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 },
      },
      {
        label: "Ingredients",
        labelStyle: { verticalAlign: "top", maxWidth: 205, minWidth: 105 },
        contentStyle: { verticalAlign: "top", minWidth: "6vw" },
        // children: master.ingredients,
        children: (
          <Input
            onChange={(e) => {
              setFormDetail((state) => ({
                ...state,
                ingredients: e.target.value,
              }));
            }}
            value={formDetail.ingredients}
            placeholder="Enter Ingredients"
            style={{ width: "100%" }}
          />
        ),
        span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
      },
      {
        label: "Allergen information ",
        labelStyle: { verticalAlign: "top", maxWidth: 205, minWidth: 120 },
        contentStyle: { verticalAlign: "top", minWidth: "6vw" },
        children: (
          <Input
            onChange={(e) => {
              setFormDetail((state) => ({
                ...state,
                allergenic_info: e.target.value,
              }));
            }}
            value={formDetail.allergenic_info}
            placeholder="Enter Allergen Information"
            style={{ width: "100%" }}
          />
        ),
        span: { xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 },
      },
      {
        label: "Product Description",
        labelStyle: { verticalAlign: "top", maxWidth: 205, minWidth: 165 },
        contentStyle: { verticalAlign: "top", minWidth: "6vw" },
        children: (
          <Input
            onChange={(e) => {
              setFormDetail((state) => ({
                ...state,
                product_description: e.target.value,
              }));
            }}
            value={formDetail.product_description}
            placeholder="Enter Product Description"
            style={{ width: "100%" }}
          />
        ),
      },
      {
        label: "Allergenic ",
        labelStyle: { verticalAlign: "top", maxWidth: 205, minWidth: 105 },
        contentStyle: { verticalAlign: "top", minWidth: "6vw" },
        // children: master.allergen_standards,
        children: (
          <AutoComplete
            style={{ height: 40, width: "100%" }}
            onChange={(value) => {
              setFormDetail((state) => ({
                ...state,
                allergenic: value,
              }));
            }}
            value={formDetail.allergenic}
            options={allergenOptions}
            placeholder="Select Allergenic life."
            filterOption={(inputValue, option) =>
              option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1
            }
            allowClear
            dropdownRender={(menu) => (
              <>
                {menu}
                <Divider style={{ margin: "4px 0" }} />
                <Button
                  type="link"
                  block
                  style={{ textAlign: "left" }}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => setOpenAllergen(true)}
                >
                  + จัดการข้อความกฎหมาย Allergen
                </Button>
              </>
            )}
          />
        ),
        span: { xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 },
      },
      // {
      //   // label: "Allergenic ",
      //   // labelStyle: { verticalAlign: "top", maxWidth: 205, minWidth: 105 },
      //   // contentStyle: { verticalAlign: "top", minWidth: "6vw" },
      //   // children: master.spname,
      //   children: (
      //     <Input
      //       onChange={(e) => {
      //         setFormDetail((state) => ({
      //           ...state,
      //           spname: e.target.value,
      //         }));
      //       }}
      //       value={formDetail.spname}
      //       placeholder="Enter Sample Code"
      //       style={{ width: "100%" }}
      //     />
      //   ),
      //   span: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 },
      // },
    ];
  };

  return (
    <div className="productspecification-manage">
      <div
        id="productspecification-manage"
        className="px-0 sm:px-0 md:px-8 lg:px-8"
      >
        <Space direction="vertical" className="flex gap-4">
          {SectionTop}
          <Card style={{ backgroundColor: "#f0f0f0" }}>
            {SectionChooseProduct}
          </Card>
          <Form
            form={form}
            layout="vertical"
            className="width-100"
            autoComplete="off"
          >
            {choosed ? (
              <>
                <Card style={{ backgroundColor: "#f0f0f0" }}>
                  <Descriptions
                    bordered
                    column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
                    items={dsItems()}
                  />
                  <Card style={{ backgroundColor: "#f0f0f0" }}>
                    {SectionDescription}
                  </Card>
                </Card>
                <Card>
                  <Space
                    direction="vertical"
                    size="middle"
                    style={{ display: "flex", position: "relative" }}
                    className="sample-request-modal"
                  >
                    <Table
                      title={() => (
                        <Typography.Title
                          className="m-0 !text-zinc-800"
                          level={3}
                        >
                          Customer List
                        </Typography.Title>
                      )}
                      components={componentsEditable}
                      rowClassName={() => "editable-row"}
                      bordered
                      dataSource={parametersCustomer || []}
                      columns={columnCus}
                      pagination={false}
                      rowKey="seq"
                      locale={{
                        emptyText: (
                          <span>No data available, please add some data.</span>
                        ),
                      }}
                      scroll={{ x: "max-content" }}
                      size="small"
                    />
                    <Row style={{ paddingInline: 14 }}>
                      <Col
                        span={24}
                        style={{ display: "flex", justifyContent: "center" }}
                        className="width-100 append-step"
                      >
                        <Button
                          shape="circle"
                          icon={<PlusCircleOutlined />}
                          style={{
                            width: "2.5rem",
                            boxShadow: "none",
                            lineHeight: "2.5rem",
                          }}
                          onClick={() => {
                            handleAddParameterCustomer();
                          }}
                        ></Button>
                      </Col>
                    </Row>
                  </Space>
                </Card>
                <Card>
                  <Space
                    direction="vertical"
                    size="middle"
                    style={{ display: "flex", position: "relative" }}
                    className="sample-request-modal"
                  >
                    <Table
                      title={() => (
                        <Typography.Title
                          className="m-0 !text-zinc-800"
                          level={3}
                        >
                          Physical & Chemical Specification
                        </Typography.Title>
                      )}
                      components={componentsEditable}
                      rowClassName={() => "editable-row"}
                      bordered
                      dataSource={parameters || []}
                      columns={column}
                      pagination={false}
                      rowKey="seq"
                      locale={{
                        emptyText: (
                          <span>No data available, please add some data.</span>
                        ),
                      }}
                      scroll={{ x: "max-content" }}
                      size="small"
                    />
                    <Row style={{ paddingInline: 14 }}>
                      <Col
                        span={24}
                        style={{ display: "flex", justifyContent: "center" }}
                        className="width-100 append-step"
                      >
                        <Button
                          shape="circle"
                          icon={<PlusCircleOutlined />}
                          style={{
                            width: "2.5rem",
                            boxShadow: "none",
                            lineHeight: "2.5rem",
                          }}
                          onClick={() => {
                            handleAddParameter();
                          }}
                        ></Button>
                      </Col>
                    </Row>
                  </Space>
                </Card>
                <Card>
                  <Space
                    direction="vertical"
                    size="middle"
                    style={{ display: "flex", position: "relative" }}
                    className="sample-request-modal"
                  >
                    <Table
                      title={() => SectionChooseMicro}
                      components={componentsEditable}
                      rowClassName={() => "editable-row"}
                      bordered
                      dataSource={parametersMicro || []}
                      columns={columnMicrobiological}
                      pagination={false}
                      rowKey="seq"
                      locale={{
                        emptyText: (
                          <span>No data available, please add some data.</span>
                        ),
                      }}
                      scroll={{ x: "max-content" }}
                      size="small"
                    />
                  </Space>
                  <Card style={{ backgroundColor: "#f0f0f0" }}>
                    {SectionMicro}
                  </Card>
                </Card>
                <Card>
                  <Space
                    direction="vertical"
                    size="middle"
                    style={{ display: "flex", position: "relative" }}
                    className="sample-request-modal"
                  >
                    <Table
                      title={() => SectionChooseMetal}
                      bordered
                      dataSource={defaultParamenterMetal || []}
                      columns={columnMetal}
                      pagination={false}
                      rowKey="seq"
                      locale={{
                        emptyText: (
                          <span>No data available, please add some data.</span>
                        ),
                      }}
                      scroll={{ x: "max-content" }}
                      size="small"
                    />
                  </Space>
                  <Card style={{ backgroundColor: "#f0f0f0" }}>
                    {SectionMetal}
                  </Card>
                </Card>
                <Card style={{ backgroundColor: "#fff" }}>
                  <Card
                    style={{
                      backgroundColor: "#f0f0f0",
                      border: "1px solid #d9d9d9",
                      borderRadius: 8,
                      marginBottom: 12,
                    }}
                  >
                    {SectionChooseTreatment}
                  </Card>
                  {choosed ? <>{SectionStep}</> : <Empty description={false} />}
                </Card>
                <Card>
                  <Form form={form} layout="vertical" autoComplete="off">
                    <Row
                      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                      className="m-0"
                    >
                      <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <Form.Item
                          label="Storage Conditions :"
                          name="storage_conditions"
                        >
                          <AutoComplete
                            style={{ height: 40, width: "100%" }}
                            options={opStorageConditions}
                            placeholder="Enter Storage Conditions."
                            onChange={(value) => {
                              setFormDetail((state) => ({
                                ...state,
                                storage_conditions: value,
                              }));
                            }}
                            filterOption={(inputValue, option) =>
                              option.value
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                            allowClear
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <Form.Item label="Shelf life :" name="shelf_life">
                          <InputNumber
                            controls={false}
                            value={formDetail.shelf_life}
                            onChange={(value) => {
                              setFormDetail((state) => ({
                                ...state,
                                shelf_life: value,
                              }));
                            }}
                            // onBlur={(e) => {
                            //   handleShelfLifeChange(e.target.value);
                            // }}
                            addonAfter={
                              <Select
                                className="shelf-unit-select"
                                value={formDetail.shelf_life_unit}
                                // onChange={(e) => handleShelfLifeUnitChange(e)}
                                style={{ width: 110, paddingInline: 6 }}
                                menuItemSelectedIcon={<CheckCircleFilled />}
                              >
                                <Select.Option value="day">Days</Select.Option>
                                <Select.Option value="week">
                                  Weeks
                                </Select.Option>
                                <Select.Option value="month">
                                  Months
                                </Select.Option>
                                <Select.Option value="year">
                                  Years
                                </Select.Option>
                              </Select>
                            }
                            placeholder="Enter Shelf Life"
                            min={0}
                            style={{ width: "100%" }}
                            className="input-40"
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <Form.Item label="Halal Status :" name="halal_status">
                          <AutoComplete
                            style={{ height: 40, width: "100%" }}
                            options={halalConditions}
                            placeholder="Enter Halal Status."
                            onChange={(value) => {
                              setFormDetail((state) => ({
                                ...state,
                                halal_status: value,
                              }));
                            }}
                            value={formDetail.halal_status}
                            filterOption={(inputValue, option) =>
                              option.value
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                            allowClear
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <Form.Item label="GMO Status :" name="gmo_status">
                          <AutoComplete
                            style={{ height: 40, width: "100%" }}
                            options={gmoConditions}
                            placeholder="Enter GMO Status."
                            onChange={(value) => {
                              setFormDetail((state) => ({
                                ...state,
                                gmo_status: value,
                              }));
                            }}
                            value={formDetail.gmo_status}
                            filterOption={(inputValue, option) =>
                              option.value
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                            allowClear
                          />
                        </Form.Item>
                      </Col>

                      {/* <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item label="Additional :" name="additional">
                          <Input.TextArea
                            placeholder="Enter Additional."
                            allowClear
                          />
                        </Form.Item>
                      </Col> */}
                    </Row>
                  </Form>
                </Card>
                <Card>
                  <Space
                    direction="vertical"
                    size="middle"
                    style={{ display: "flex", position: "relative" }}
                    className="sample-request-modal"
                  >
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                      <Flex
                        vertical
                        align="top"
                        className="justify-start md:justify-start lg:justify-start xl:justify-start width-100"
                      >
                        <Form.Item name="remark_print" label="หมายเหตุ">
                          <Input.TextArea
                            rows={5}
                            placeholder="หมายเหตุ Print ออกไปกับเอกสาร"
                            value={formDetail.remark_print}
                            onChange={(e) => {
                              setFormDetail((state) => ({
                                ...state,
                                remark_print: e.target.value,
                              }));
                            }}
                          />
                        </Form.Item>
                      </Flex>
                    </Col>
                  </Space>
                </Card>
                <br></br>
                {SectionBottom}
              </>
            ) : (
              <Empty
                image={false}
                imageStyle={{ display: "none" }}
                description={false}
              >
                Empty data for Product Specification. Please choose Sample
                Preparation.
              </Empty>
            )}
          </Form>
        </Space>
      </div>

      {openSPModal && (
        <ModalSamplePreparation
          show={openSPModal}
          close={() => setOpenSPModal(false)}
          values={handleChooseValue}
        />
      )}

      {openCustomer && (
        <ModalCustomers
          show={openCustomer}
          close={() => setOpenCustomer(false)}
          values={handleChooseCustomer}
        />
      )}

      {openAllergen && (
        <ModalAllergenStandard
          show={openAllergen}
          close={() => setOpenAllergen(false)}
          defaultText={formDetail.allergenic}
          onChanged={loadAllergenOptions}
        />
      )}

      {isOpenModalMicro && (
        <ModalMicrobiological
          show={isOpenModalMicro}
          close={() => setIsOpenModalMicro(false)}
          values={(v) => {
            handleChooseMicroValue(v);
          }}
        ></ModalMicrobiological>
      )}

      {isOpenModalTreatment && (
        <ModalTreatment
          show={isOpenModalTreatment}
          close={() => setIsOpenModalTreatment(false)}
          values={(v) => {
            handleChooseTreatmentValue(v);
          }}
        ></ModalTreatment>
      )}
    </div>
  );
}

export default ProductSpecificationManage;
